import { apiFetch } from './client';

export const listNotifications = (token) => apiFetch(token, '/notifications');

export const createNotification = (token, payload) =>
  apiFetch(token, '/notifications', { method: 'POST', body: JSON.stringify(payload) });

export const updateNotification = (token, notificationId, payload) =>
  apiFetch(token, `/notifications/${notificationId}`, {
    method: 'PATCH',
    body: JSON.stringify(payload),
  });

export const deleteNotification = (token, notificationId) =>
  apiFetch(token, `/notifications/${notificationId}`, { method: 'DELETE' });

export const resendNotification = (token, notificationId) =>
  apiFetch(token, `/notifications/${notificationId}/resend`, { method: 'POST' });
